






































import { Component, Prop, Vue, Inject } from "vue-property-decorator";
import moment from "moment";
import { getModule } from "vuex-module-decorators";
import escapeHTML from "lodash.escape";

import InlineSpinner from "@/lib/components/InlineSpinner.vue";

import dataStore from "@/store";
import AccountStore from "@/modules/account/store";
import AuthenticatedUserProvider from "@/modules/account/authenticated-user-provider.service";
import AuthenticatedUser from "@/modules/account/authenticated-user.model";

import MessagesHistoryAttachmentsGallery from "./AttachmentsGallery.vue";

import MessagingStore from "../../store";
import { ChannelValue } from "../../channel.value";
import Message from "../../message.model";

@Component({
  components: {
    InlineSpinner,
    MessagesHistoryAttachmentsGallery,
  },
})
export default class MessagesHistoryItem extends Vue {
  @Prop({ required: true })
  public readonly messageId!: string;

  @Inject("AuthenticatedUserProvider")
  private fUserProvider!: AuthenticatedUserProvider;

  private fAccountDataStore: AccountStore;
  private fMessagingDataStore: MessagingStore;

  get channelClass(): string {
    if (!this.message) {
      return "";
    }

    switch (this.message.channel) {
      case ChannelValue.STORE_CUSTOMER:
        return "-store-customer-channel";
      case ChannelValue.PRIVATE:
        return "-private";
    }

    return "";
  }

  get createdAt(): string {
    if (!this.message) {
      return "";
    }

    const date = moment(this.message.createdAt);
    if (date.isSame(moment(), "day")) {
      return date.format("LT");
    } else {
      return date.format("ll LT");
    }
  }

  get isMyGroupMessage(): boolean {
    if (!this.message) {
      return false;
    }

    return this.message.isForwardDirection === this.isUserOnChannelFrontEdge();
  }

  get isUnread(): boolean {
    if (!this.message) {
      return false;
    }

    return !this.message.isRead;
  }

  get message(): Message | undefined {
    return this.fMessagingDataStore.getMessageById(this.messageId);
  }

  get sanitizedMessageText(): string | undefined {
    if (!this.message) {
      return undefined;
    }

    return escapeHTML(this.message.text);
  }

  get sender(): string {
    if (!this.message) {
      return "";
    }

    if (!this.isMyGroupMessage) {
      return "Designer";
    }

    const userInfo = this.fAccountDataStore.getUserInfoById(
      this.message.sender
    );

    if (!userInfo) {
      return "";
    }

    return `${userInfo.firstName} ${userInfo.lastName}`;
  }

  constructor() {
    super();
    this.fMessagingDataStore = getModule(MessagingStore, dataStore);
    this.fAccountDataStore = getModule(AccountStore, dataStore);
  }

  private isUserOnChannelFrontEdge(): boolean {
    const user = this.fUserProvider.getUser();

    if (!user) {
      return false;
    }

    return [
      AuthenticatedUser.ROLE_STORE,
      AuthenticatedUser.ROLE_ADMIN,
    ].includes(user.role);
  }
}
